import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {Button} from 'primereact/button';
import {InputSwitch} from 'primereact/inputswitch';
//datatable
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {auth, management} from "../../actions";
import '../../css/buttons.css'
import '../../css/datatable.css'
import {Link} from 'react-router-dom';

const UserList = state => {

    const [userList, setUserList] = useState([]);
    const user_list_role = !!localStorage.getItem('user_list');
    const user_add_role = !!localStorage.getItem('user_add');
    const [userUrl, setUserUrl] = useState('/api/user/list/');
    const [userUrl2, setUserUrl2] = useState('/api/user/list/');
    const dt = useRef(null);
    const [userLoading, setUserLoading] = useState(false);
    const [nextPageUrl, setNextPageUrl] = useState('none');
    const [previousPageUrl, setPreviousPageUrl] = useState('none');
    const [totalUser, setTotalUser] = useState(null);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 1,
    });

    useEffect(() => {
        if (user_list_role) {
            getUsers(userUrl)
        }

    }, []);

    useEffect(() => {
        if (state.management.type === 'FETCH_USERS') {
            setUserList(state.management.management);
            state.loadUser()
        } else if (state.management.type === 'USER_UPDATE_STATUS') {
            state.fetchUsers();
        }


    }, [state.management.type]);


    const setUserStatus = (rowData) => {
        let flag = rowData['user_flag_active'];
        let user_id = rowData['user_id'];
        let status_data = {};
        if (!flag) {
            rowData['user_flag_active'] = true;
            status_data = {
                user_flag_active: true
            };
        } else {
            rowData['user_flag_active'] = false;
            status_data = {
                user_flag_active: false
            };
            //this.props.updateLogStatus(id , status_data);
        }
        state.updateUserStatus(user_id, status_data);
    }

    const getUsers = (userUrl) => {
        setUserLoading(true);
        setUserList([]);
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;

            // //console.log("*** header: ***",headers);
            fetch(userUrl, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            setUserLoading(false);
                            return {status: res.status, data};

                        })
                    } else {
                        //console.log("Server Error!");
                        setUserLoading(false);
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        setUserLoading(false);
                        setTotalUser(data.count);
                        setNextPageUrl(data.next)
                        setPreviousPageUrl(data.previous);
                        setUserList(data.results);

                    } else if (res.status === 401) {
                        setUserLoading(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setUserLoading(false);
                        throw res.data;

                    }
                })
        }
    }

    const actionTemplate = (rowData) => {
        return <div>
            <InputSwitch
                checked={!rowData['user_flag_active']}
                onChange={() => setUserStatus(rowData)}
                style={{marginRight: '.6em'}}
            />
            <Link to={`/user/${rowData['user_username']}/`}>
                <Button
                    title="Kullanıcı Düzenle"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    style={{maxHeight: '1.72em', maxWidth: '1.83em'}}
                    // onClick={() => selectUser(rowData['user_username'])}
                >
                </Button>

            </Link>

        </div>;
    }

    const removeParam = (key, sourceURL) => {
        let rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }

    const onPage = (event) => {
        const page = event.page + 1;
        let _lazyParams = {...lazyParams, ...event};
        setLazyParams(_lazyParams);
        if (page === 0) {
            getUsers(removeParam('page', userUrl));
        } else {
            let url = null;
            if (userUrl.includes('?')) {

                if (userUrl.includes('?page')) {

                    url = removeParam('page', userUrl) + '?page=' + page;
                } else if (userUrl.includes('page')) {

                    url = removeParam('page', userUrl) + '&page=' + page;
                } else {

                    url = userUrl + '&page=' + page;
                }
                setUserUrl(url)
            } else {
                url = userUrl2 + '?page=' + page;
                setUserUrl(url)
            }
            getUsers(url);
        }
    }

    const onFilter = (event) => {
        const data = Object.keys(event.filters);
        if (data.length) {
            let filterParam = '';
            let index = 0;
            data.forEach(function (key) {
                const query = event.filters[key].value;
                if (index === 0) {
                    filterParam = key.replaceAll('.', '_') + '=' + query;
                } else {
                    getUsers(userUrl2);
                    // filterParam = filterParam + '&' + key.replaceAll('.', '_') + '=' + query;
                }
                index++;
            });
            const url = userUrl2 + '?' + filterParam;
            setUserUrl(url);
            getUsers(url);
        } else {
            getUsers(userUrl2);
        }
        let _lazyParams = {...lazyParams, ...event};
        _lazyParams['first'] = 0;
        setLazyParams(_lazyParams);
    }

    const idBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.user_id}
            </React.Fragment>
        );
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.person[0].pers_name}
            </React.Fragment>
        );
    }

    const surnameBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.person[0].pers_surname}
            </React.Fragment>
        );
    }

    const userNameBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.user_username}
            </React.Fragment>
        );
    }

    const emailBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.user_email}
            </React.Fragment>
        );
    }


    ////console.log(userList)
    if (user_list_role) {
        // const footer = "Toplamda " + userList.length + ' kişi kayıtlıdır';
        const header = (
            <div style={{'textAlign': 'center', fontSize: '15px'}}>
                Sistem Kullanıcıları &nbsp;&nbsp;
                <Button icon="pi pi-user-plus"
                        style={{visibility: user_add_role ? 'visible' : 'hidden'}}
                        title="Kullanıcı Ekle"
                        onClick={() => window.location.hash = '/user'}/>
            </div>
        );

        return (
            <div className="datatable-responsive-demo">

                <div className="card">
                    <h5><b>Sistem Kullanıcıları</b></h5>
                    <p>Sayfalandırma, sıralama ve filtreleme </p>
                    <DataTable
                        ref={dt}
                        value={userList}
                        paginator
                        className="p-datatable-responsive-demo"
                        dataKey="id"
                        rowHover
                        emptyMessage="Kayıt bulunamadı"
                        lazy={true}
                        rows={20}
                        first={lazyParams.first}
                        filters={lazyParams.filters}
                        totalRecords={totalUser}
                        onPage={onPage}
                        loading={userLoading}
                        responsive
                        onFilter={onFilter}
                    >
                        <Column header="İşlevler" body={actionTemplate} style={{textAlign: 'center', width: '7em'}}/>
                        <Column field="user_id" header="No" filter body={idBodyTemplate} style={{textAlign: 'center'}}/>
                        <Column field="pers_name" header="Adı" filter body={nameBodyTemplate}
                                style={{textAlign: 'center'}}/>
                        <Column field="pers_surname" header="Soyadı" filter body={surnameBodyTemplate}
                                style={{textAlign: 'center'}}/>
                        <Column field="user_username" header="Kullanıcı Adı" filter body={userNameBodyTemplate}
                                style={{textAlign: 'center'}}/>
                        <Column field="user_email" header="E-Posta" filter body={emailBodyTemplate}
                                style={{overflowWrap: 'break-word', textAlign: 'center'}}/>
                        <Column field="create_time_user" header="Kayıt Tarihi"
                                style={{overflowWrap: 'break-word', textAlign: 'center'}}/>

                    </DataTable>
                </div>
            </div>

        )


    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUsers: () => {
            dispatch(management.fetchUsers());
        },
        updateUserStatus: (user_id, content_data) => {
            return dispatch(management.updateUserStatus(user_id, content_data));
        },
        logout: () => dispatch(auth.logout()),

        loadUser: () => {
            return dispatch(auth.loadUser());
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserList);



// WEBPACK FOOTER //
// ./src/pages/userpages/UserList.jsx